module.exports = __webpack_public_path__ + "static/media/img_fenlei12.3d1c9251.png";